import { useState } from "react";
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardHeader,
    Content,
    FloatInput,
    FormGroup,
    LoadingSpinner,
} from "@webtypen/react-components";
import { Page } from "../components";
import { ApiHelper } from "../helpers";

export const ChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPassword2, setNewPassword2] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState(null);

    const submit = (e) => {
        e.preventDefault();

        if (!newPassword || newPassword.trim().length < 5) {
            setAlert(["danger", "Das neue Passwort muss mindestens 5 Zeichen lang sein"]);
            return;
        }

        if (newPassword !== newPassword2) {
            setAlert(["danger", "Die beiden Passwörter stimmen nicht überein"]);
            return;
        }

        if (!currentPassword || currentPassword.trim() === "") {
            setAlert(["danger", "Bitte gib dein aktuelles Passwort ein"]);
            return;
        }

        e.preventDefault();
        setIsLoading(true);
        setAlert(null);
        ApiHelper.request("/api/auth/change-password", {
            new_password: newPassword,
            password: currentPassword,
        })
            .then((response) => {
                if (response.status === "success") {
                    setNewPassword("");
                    setNewPassword2("");
                    setCurrentPassword("");
                    setAlert(["success", "Das Passwort wurde erfolgreich geändert ..."]);
                } else {
                    setAlert([
                        "danger",
                        response.status === "error" && response.message && response.message.trim() !== ""
                            ? response.message.trim()
                            : "Es ist ein unerwarteter Fehler aufgetreten ...",
                    ]);
                }
                setIsLoading(false);
            })
            .catch((e) => {
                console.error(e);
                setAlert([
                    "danger",
                    e && e.data && e.data.status === "error" && e.data.message && e.data.message.trim() !== ""
                        ? e.data.message.trim()
                        : "Es ist ein unerwarteter Fehler aufgetreten ...",
                ]);
                setIsLoading(false);
            });
    };

    return (
        <Page title="Passwort ändern">
            <Content>
                <div style={{ maxWidth: 500, margin: "auto" }}>
                    <Card>
                        <CardHeader>Passwort ändern</CardHeader>
                        <CardBody>
                            {alert ? <Alert color={alert[0]}>{alert[1]}</Alert> : null}

                            <form onSubmit={submit}>
                                <FloatInput
                                    type="password"
                                    placeholder="Neues Passwort"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    disabled={isLoading}
                                    className="mb-1"
                                />
                                <FloatInput
                                    type="password"
                                    placeholder="Neues Passwort wiederholen"
                                    value={newPassword2}
                                    onChange={(e) => setNewPassword2(e.target.value)}
                                    className="mb-1"
                                />
                                <FloatInput
                                    type="password"
                                    placeholder="Aktuelles Passwort"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    className="mb-1 mt-4"
                                />
                                <Button disabled={isLoading} primary>
                                    {isLoading ? <LoadingSpinner /> : "Speichern"}
                                </Button>
                            </form>
                        </CardBody>
                    </Card>
                </div>
            </Content>
        </Page>
    );
};
